import React, { useState, useEffect, useReducer, useRef } from 'react';
import '../css/leftslide.css';

const LeftSlide = ({ setIsCameraOn, webcamRef }) => {
  let TrialId = 0;
  const [ignore, setForceRefresh] = useReducer(x => x + 1, 0);
  const inputRef = useRef(null);

  const URL = process.env.REACT_APP_API_URL;//"http://127.0.0.1:8000";

  let recogurl = "/kathakali/mudra/recognize?mediaId=";
  let task = "Kathakali-Mudra-Recognition";
  let errMessage = "Mudra was not proper, try again";


  const fetchOnLoad = async () => {
    try {
      const response = await fetch(URL + "/");

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      console.log(response);

    } catch (err) {
      showModal("API Server Not Available");
    }
  };

  useEffect(() => {
    fetchOnLoad();
  }, []);

  const stopCamera = () => {
    document.getElementById("imagePreview").innerHTML = "";
    setIsCameraOn(false);
  };

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = function(e) {
        const imagePreview = document.getElementById('imagePreview');
        if (imagePreview) {
          imagePreview.innerHTML = `<img src="${e.target.result}" alt="Preview "  className="rounded" />`;
        }
      };
      reader.readAsDataURL(file);
    }
    fetchData();
  };

  const captureImage2 = () => {
    const timerElement = document.getElementById("timer");
    document.getElementById("mainCam").style.filter = "blur(8px)";
    let countdown = 3; // Initial countdown value in seconds

    const updateCountdown = () => {
      timerElement.textContent = countdown;
      countdown -= 1;
      if (countdown >= 0) {
        setTimeout(updateCountdown, 1000);
      } else {
        timerElement.textContent = "";
        //document.getElementById("capturebtn").innerHTML = "Sending...";
        captureImage();
      }
    };

    updateCountdown();
    setTimeout(captureImage, 3000);
    document.getElementById("mainCam").style.filter = "blur(0)";
  };

  const captureImage = async () => {
    console.log(webcamRef.current);

    if (webcamRef.current) {
      const base64Image = webcamRef.current.getScreenshot();
      console.log(base64Image);

      const byteString = atob(base64Image.split(',')[1]);
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([ab], { type: 'image/png' });
      const file = new File([blob], 'captured.png', { type: 'image/png' });

      const fileInput = document.getElementById('file');
      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(file);
      fileInput.files = dataTransfer.files;

      fileValidation();
    }
  };

  const predictMudra = async (mediaId) => {
    try {
      const response = await fetch(URL + recogurl + mediaId);
      console.log(response);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const result = await response.json();
      console.log(result);
      TrialId = result.trialId;
      console.log(result.label);
      showMudra(result.label);
    } catch (err) {
      console.log(err);

      showModal(errMessage);
    }
  };

  async function test() {
    try {
      const response = await fetch(URL + "/",);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      console.log(response)
      alert(result)
    }
    catch (err) {
      alert(err)
    }
  }

  const fetchData = async () => {
    console.log("fetch file")
    try {
      const form = document.getElementById("myForm");
      const formData = new FormData(form);
      let action = form.action + task;

      const response = await fetch(action, {
        method: form.method,
        body: formData,
      });
      //document.getElementById("capturebtn").innerHTML = "Done...";
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      console.log(result);
      //document.getElementById("capturebtn").innerHTML = "Capture Image";
      predictMudra(result.mediaId);
    } catch (err) {
      console.error('Error:', err);


    }
  };


  const SubmitFeedback = async () => {
    // Hide image preview
    const imagePreview = document.getElementById("imagePrevieww");
    if (imagePreview) {
      imagePreview.style.display = "none";
    } else {
      console.error("Element with id 'imagePrevieww' not found.");
      return;
    }

    // Get feedback value
    const predictInput = document.getElementById("predict");
    if (!predictInput) {
      console.error("Element with id 'predict' not found.");
      return;
    }

    const feedback = predictInput.value === "true";

    try {
      // Construct URL with URLSearchParams
      const url = new URL(URL + "/trial/feedback");
      url.searchParams.append("trialId", TrialId);
      url.searchParams.append("correct", feedback);

      // Send feedback to server
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      showModal(result.message);
    } catch (error) {
      console.error("An error occurred while submitting feedback:", error);
      // Optionally handle error, display error message, etc.
    }
  };

  function showModal(message) {
    const snackbar = document.getElementById("snackbar");
    if (snackbar) {
      snackbar.innerHTML = message;
      snackbar.className = "show";
      setTimeout(function () {
        snackbar.className = snackbar.className.replace("show", "");
      }, 3000);
    } else {
      console.error("Element with id 'snackbar' not found.");
    }
  }


  function showMudra(message) {
    var modal = document.getElementsByClassName('confirm');
    var firstmodel = modal[0];
    var span2 = document.getElementsByClassName("submitMudra")[0];
    var messageElement = document.getElementById("yourMudra");
    messageElement.innerHTML = message;
    firstmodel.style.display = "block";
    // span2.onclick = function () {
    //   firstmodel.style.display = "none";
    // };
    window.onclick = function (event) {
      if (event.target === firstmodel) {
        firstmodel.style.display = "none";
      }
    };
  }
  const handleCheckboxChange = (event) => {
    console.log(event.target.value)
    if (event.target.checked) {
      recogurl = "/indian-sign/fingerspell/recognize?mediaId=";
      task = "ISL-Finger-Spell-Recognition";
      errMessage = "Sign was not proper, try again";
      document.getElementById("modal-heading").innerHTML = 'Your Sign';
      document.getElementById("modal-body").innerHTML = 'The Sign you are representing is : <strong id="yourMudra"></strong>'
    } else {
      recogurl = "/kathakali/mudra/recognize?mediaId=";
      task = "Kathakali-Mudra-Recognition";
      errMessage = "Mudra was not proper, try again";
      document.getElementById("modal-heading").innerHTML = 'Your Mudra';
      document.getElementById("modal-body").innerHTML = 'The Mudra you are representing is : <strong id="yourMudra"></strong>'
    }
  };

  const handleCheckboxChange2 = (event) => {
    console.log(event.target.value)
    if (event.target.checked) {
      recogurl = "/kathakali/mudra/recognize?mediaId=";
      task = "Kathakali-Mudra-Recognition";
      errMessage = "Mudra was not proper, try again";
      document.getElementById("modal-heading").innerHTML = 'Your Mudra';
      document.getElementById("modal-body").innerHTML = 'The Mudra you are representing is : <strong id="yourMudra"></strong>'
    } else {
      recogurl = "/indian-sign/fingerspell/recognize?mediaId=";
      task = "ISL-Finger-Spell-Recognition";
      errMessage = "Sign was not proper, try again";
      document.getElementById("modal-heading").innerHTML = 'Your Sign';
      document.getElementById("modal-body").innerHTML = 'The Sign you are representing is : <strong id="yourMudra"></strong>';

    }
  };

  function fileValidation() {
    var fileInput = document.getElementById('file');
    var filePath = fileInput.value;

    var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;

    if (!allowedExtensions.exec(filePath)) {
      showModal("Invalid File Type");
      fileInput.value = '';
      return false;
    } else {
      if (fileInput.files && fileInput.files[0]) {
        var reader = new FileReader();
        reader.onload = function (e) {
          document.getElementById(
            'imagePreview').innerHTML =
            '<img src="' + e.target.result
            + '" className="rounded"/>';
        };

        reader.readAsDataURL(fileInput.files[0]);
        stopCamera();

        fetchData();
      }
    }
  }

  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (event) => {

    const file = event.target.files[0];
    if (file) {
      const { name: fileName, size } = file;
      const fileSize = (size / 1000).toFixed(2);
      const fileNameAndSize = `${fileName} - ${fileSize}KB`;
      setSelectedFile(fileNameAndSize);
    } else {
      setSelectedFile(null);
    }
  };

  var actionApiUrl = URL + "/mediafile?mediaType=IMAGE&task=";

  return (
    <div className='left'>
      <button onClick={captureImage2} id="capturebtn" className="btn  capture" >Capture Image</button>
      <br />

      <form
        id="myForm"
        method="post"
        encType="multipart/form-data"
        action={actionApiUrl}>
        {/* <br /> */}
        <br />

        <label for="file" className='imgupload'>
          <input type="file" id="file" name="file" class="Upload" onChange={handleFileSelect} />
          Upload Image
        </label>


        {/* <br /> */}
        {/* <br /> */}

      </form>

      <br />
      <br />

      {/* <label htmlFor="choice">ISL Fingerspelling</label> */}
      <div class="grid">
        <h5>Features</h5>

        <label class="form-control">
          <input type="radio" name="checkbox" value={"1"} checked onClick={handleCheckboxChange2} />
          Kathakali Mudra Detection
        </label>

        <label class="form-control">
          <input type="radio" name="checkbox" id="choice" value={"2"} onClick={handleCheckboxChange} />
          Fingerspell Detection
        </label>
      </div>
      <div id="myModal" className="modal">
        <div className="modal-content">
          <span className="close">&times;</span>
          <p id="modalMessage"></p>
        </div>
      </div>
      <div id="snackbar">Some text some message..</div>
      <div class="confirm" id="imagePrevieww">
        <div id="imagePreview" className='hidden' />
        <h1 id="modal-heading">Your Mudra</h1>
        <p id='modal-body'>The mudra you are representing is :  <strong id="yourMudra"></strong></p>
        <div class="modal-footer">
          <button type="button" className="btn btn-link btn-primary text-decoration-none accept" data-bs-dismiss="modal" onClick={() => SubmitFeedback(true)}><strong>Accept</strong></button>
          <button type="button" className="btn btn-link btn-danger text-decoration-none reject" data-bs-dismiss="modal" onClick={() => SubmitFeedback(false)}>Reject</button>
        </div>


      </div>
    </div>
  );
};

export default LeftSlide;
